<template>
  <div class="page">
    <el-form :inline="true" ref="form" label-width="120px">
		<div style="display: flex; justify-content:space-between;">
			<div>
				<div style="display: flex;align-items: center;">
					<el-form-item label="服务商">
						<el-cascader v-model="spIdDepartName" :options="providerOptions" 
							:props="{ checkStrictly: true, expandTrigger: 'hover'}"  @change="onProviderChanged">
						</el-cascader>
					</el-form-item>
					<el-popover placement="right" :width="'176'" trigger="click" v-if="$qiniu != null && salesMan != null">
						<div v-if="salesMan.wechatQRCode != ''">
							<img :src="$qiniu.domain + salesMan.wechatQRCode" style="width: 150px;height: 150px;display: block;">
							<span style="display: block;color: teal;width: 150px;text-align: center;">微信联系：{{salesMan.userName}}</span>
							<span style="display: block;color: teal;width: 150px;text-align: center;">{{salesMan.contacts}}</span>
						</div>
						<div style="height: 30px; cursor: pointer;" slot="reference" v-if="salesMan != null">
							<font-awesome-icon :icon="['fab', 'weixin']" style="margin-right: 12px;color: rgb(42,161,69);font-size: 22px;" />
							<span style="color: rgb(42,161,69);font-size: 16px;font-weight: bold;">{{'业务:' + salesMan.userName}}</span>
						</div>									
					</el-popover>					
				</div>
				<div style="display: flex">
<!-- 					<el-form-item label="运单状态">
					  <el-checkbox-group v-model="wayBillState">
						<el-checkbox :label="1">待发货</el-checkbox>
						<el-checkbox :label="2">待提取</el-checkbox>
						<el-checkbox :label="3">已提取</el-checkbox>
						<el-checkbox :label="4">已签收</el-checkbox>
						<el-checkbox :label="5">已退走</el-checkbox>
					  </el-checkbox-group>
					</el-form-item>	 -->
					<el-form-item label="是否对账">
					  <el-checkbox-group v-model="clientConfirmBillval">
						<el-checkbox :label="1">已对账</el-checkbox>
						<el-checkbox :label="2">未对账</el-checkbox>
					  </el-checkbox-group>
					</el-form-item>									
				</div>
				<el-form-item label="收货时间">
				  <el-date-picker v-model="datetimerange[0]" type="date" value-format='yyyy-MM-dd HH:mm:ss' placeholder="开始日期">
				  </el-date-picker>
				  <label style="margin: 15px;">至</label>
				  <el-date-picker v-model="datetimerange[1]" type="date" value-format='yyyy-MM-dd HH:mm:ss' placeholder="结束日期">
				  </el-date-picker>
				</el-form-item>
			</div>
			<div style="align-items: flex-end;">
				<el-input type="textarea" :rows="4" placeholder="请输入运单号或转单号，多个用逗号隔开" v-model="wayBillNos" @keyup.enter.native="submitForm" style="width: 300px;margin-right: 18px;margin-bottom: 18px;"></el-input>
				<div style="align-self: flex-end;margin-bottom: 18px;margin-left: 16px;">
					<el-button type="primary" icon="el-icon-search" @click="queryWayBill">查询</el-button>
					<el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>		
				</div>
			</div>
		</div>
		<div style="display: flex">
			<div style="align-self: flex-end;margin-bottom: 18px;margin-left: 16px;">
				<el-button icon="el-icon-download" @click="handleDownload">导出</el-button>
				<el-button :disabled='!multipleSelection.length' @click="getclientConfirmBill(1)">
					<font-awesome-icon icon="marker" style="margin-right: 5px;vertical-align: baseline;font-size: 10px;" />对账标识
				</el-button>
				<el-button :disabled='!multipleSelection.length' @click="getclientConfirmBill(0)">
					<font-awesome-icon icon="signature" style="margin-right: 5px;vertical-align: baseline;font-size: 10px;" />取消标识
				</el-button>
				<el-button :disabled='!multipleSelection.length' @click="setremark">
					<font-awesome-icon icon="edit" style="margin-right: 5px;vertical-align: baseline;font-size: 10px;" />内部备注
				</el-button>			
			</div>
			<div style="width: 20px" v-if="billCountList.length > 0"></div>		
			<el-radio-group v-model="billCountLabel" size="small" v-if="billCountList.length > 0" @change="billCountItemChanged">
			  <el-radio-button v-for="(item, k) in billCountList" :key="k" :label="getBillCountLabel(item)"></el-radio-button>
			</el-radio-group>			
		</div>
    </el-form>
    <el-table-auto :ref="ref" id='reconciliation' name='运单' :column='tableConf' :table-hand='getTable' :subtable-hand='getTableDetailed' :down-hand='paraphrase' @cell-dblclick='cellclickwayBillNo' @selection-change="handleSelectionChange" style="flex: 1;display: flex;flex-direction: column;overflow: hidden;" v-contextmenu:contextmenu>
      <template #spName="{row}">
         {{getSpName(row)}}
      </template>
      <template #inTime="{row}">
        {{getDatetime(row.inTime)}}
      </template>
      <template #wayBillNo="{row}">
        <span @click="cellclickwayBillNo(row)" class="blue">{{row.wayBillNo}}</span>
      </template>
      <template #amount="{row}">
        <span class="selectspan" @click="rowClickExpand(row)">{{-row.inFreight-row.inFreightConditionAdd-row.inFreightAdd}}</span><i v-if="row.customerConfirmed" class="el-icon-check red" style="font-size: 16px;float: right;position: absolute;bottom: 0px;right: 0;font-weight: bold;"></i>
      </template>
      <template #remark="{row}">
        {{row.spCostRemark? getRemark(row.spCostRemark):''}}
      </template>
      <template #trackInfo="{row}">
        <template v-if="row.publicTrackTime && row.trackTime">
          <template v-if="row.publicTrackTime > row.trackTime">
            <div>{{'【'+row.publicTrackTime}}<div style="display: inline-block;width: 20px;"></div>{{row.publicTrackPlace+'】'}}</div>
            <div>{{row.publicTrackInfo}}</div>
          </template>
          <template v-else>
            {{row.publicTrackInfo}}
          </template>
        </template>
        <template v-else-if="row.publicTrackTime">
          <div>{{'【'+row.publicTrackTime}}<div style="display: inline-block;width: 20px;"></div>{{row.publicTrackPlace+'】'}}</div>
          <div>{{row.publicTrackInfo}}</div>
        </template>
        <template v-else>
          {{row.trackInfo}}
        </template>
      </template>
      <template #wayBillStatus="{row}">
        <template>
			<span v-if="row.wayBillStatus == 0">待走货<i class="el-icon-shopping-cart-full" style="font-size: 20px; color: red; margin: 0px 5px;"></i></span>
			<span v-if="row.wayBillStatus == 1">待提取<i class="el-icon-truck" style="font-size: 20px; color: fuchsia; margin: 0px 5px;"></i></span>
			<span v-if="row.wayBillStatus == 2">待签收<i class="el-icon-s-promotion" style="font-size: 20px; color: green; margin: 0px 5px;"></i></span>
			<span v-if="row.wayBillStatus == 3">已签收<i class="el-icon-success" style="font-size: 20px; color: blue; margin: 0px 5px;"></i></span>		
			<span v-if="row.wayBillStatus == 4">已退走<i class="el-icon-refresh-left" style="font-size: 20px; margin: 0px 5px;"></i></span>	
			<span v-if="row.wayBillStatus == 5">已作废<i class="el-icon-delete-solid" style="font-size: 20px; color: slategray; margin: 0px 5px;"></i></span>											
        </template>
      </template>
      <template #lastProblemExists="{row}">
        <span class="red">{{row.providerProblemExists}}</span>
      </template>	  
      <template #serviceInfo="{row}">
        <span class="lins" v-if="row.serviceInfo">
          <!-- 有问题状态且问题状态不能有且仅有内部问题（高位第6为）为开 -->
          <span :class="(row.serviceStatus && row.serviceStatus != 64)?'red':''">{{row.serviceInfo}}</span>
          <div style="display: inline-block;width: 20px;"></div>
          <span class="gray" v-if="row.serviceInfoTime">{{row.serviceInfoTime.substring(5, 16)}}</span>
          <div style="display: inline-block;width: 20px;"></div>
          <span class="gray" v-if="row.serviceInfoToPerson">@{{row.serviceInfoToPerson}}</span>
        </span>
      </template>
      <template #battery="{row}">
        {{row.battery === 0?'无电': row.battery === 1?'内电':row.battery=== 2? '外电':'纯电'}}
      </template>
      <template #gateDeclared="{row}">
        {{row.gateDeclared == 1?'报关':'不报关'}}
      </template>
      <template #serviceStatus="{row}">
        {{numtotitflog(row.serviceStatus,0)?'港前问题':numtotitflog(row.serviceStatus,1)?'港后问题':numtotitflog(row.serviceStatus,4)?'收货问题':numtotitflog(row.serviceStatus,5)?'欠费问题':numtotitflog(row.serviceStatus,3)?'待退走':''}}
      </template>
      <template #freight="{row}">
        {{-row.inFreight}}
      </template>	  
      <template #freightAdd="{row}">
        {{-row.inFreightAdd-row.inFreightConditionAdd}}
      </template>	  
      <template #updatedTime="{row}">
        {{getDatetime(row.updatedTime)}}
      </template>
      <template #expand="{row}">
        <el-table class="tableExpand" :data="row.list" v-loading="row.tableloading" :row-class-name="tableRowClassName" style="width: calc(100% - 100px);border-left: 1px solid #EBEEF5;float: right;">
          <el-table-column prop="billTime" label="账单时间" width="160"></el-table-column>
          <el-table-column prop="subjectName" label="科目" width="160"></el-table-column>
          <el-table-column prop="amount" label="金额" width="160">
            <template slot-scope="scope">
              {{scope.row.amount}}<i v-if="scope.row.branchConfirmed" class="el-icon-check" style="color: red;font-size: 16px;line-height: 23px;float: right;position: absolute;right: 5px;font-weight: bold;"></i>
            </template>
          </el-table-column>
          <el-table-column label="对账状态" width="200">
            <template slot-scope="scope">
              <el-switch :active-value='1' :inactive-value='0' v-model="scope.row.branchConfirmed" @change='getconfirmforbilldeat(scope.row)'></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="账单备注" show-overflow-tooltip></el-table-column>
        </el-table>
      </template>
    </el-table-auto>
    <v-contextmenu ref="contextmenu" theme='default' style="z-index:auto">
      <v-contextmenu-item @click="copyclick">复制</v-contextmenu-item>
      <v-contextmenu-item :disabled='!multipleSelection.length' @click="getclientConfirmBill(1)">标识对账</v-contextmenu-item>
      <v-contextmenu-item :disabled='!multipleSelection.length' @click="getclientConfirmBill(0)">取消标识对账</v-contextmenu-item>
      <v-contextmenu-item :disabled='!multipleSelection.length' @click="setremark">内部备注</v-contextmenu-item>
    </v-contextmenu>
  </div>
</template>

<script>
import Vue from 'vue'
import * as date from '@/utils/date'
import { page } from '@/mixins/page'
export default {
  mixins: [page],
  data() {
    return {
		ref: 'reconciliation',
		datetimerange: [date.formatDate(new Date(new Date() - 1000 * 3600 * 24 * 29), 'yyyy-MM-dd hh:mm:ss'), date.formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss')],
		// form
		clientConfirmBillval: [],
		wayBillState: [],
		freightType: 0,
		providerOptions: [],
		spIdDepartName: [],
		billCountList: [],
		billCountLabel: '',	 
		wayBillNos: '',
      // table
      tableConf: [
        //{ template: 'spName', label: '服务商', width: 90 },
        { template: 'inTime', label: '收货时间', width: 140 },
        { template: 'wayBillNo', label: '原单号', width: 120 },
        { prop: 'transBillNo', label: '转单号', width: 150 },
        { prop: 'quoteName', label: '渠道', width: 160 },
        { prop: 'destinationName', label: '目的地', width: 110 },
        { prop: 'pieces', label: '件数', width: 60 },
        { prop: 'settlementWeight', label: '结算重', width: 70 },
        { template: 'amount', label: '合计', width: 100 },
        // { template: 'serviceInfo', label: '跟进信息', width: 160 },
        { template: 'wayBillStatus', label: '运单状态', width: 100 },
        { template: 'remark', label: '账单备注', width: 200 },
        { template: 'lastProblemExists', label: '待处理问题', width: 300 },		
        //{ template: 'trackInfo', label: '轨迹信息', width: 250 },
        { prop: 'branchRemark', label: '内部备注(服务商不可见)', width: 180 },
        //{ prop: 'goodsTypeName', label: '货物类型', width: 105 },
        //{ template: 'battery', label: '电池', width: 100 },
        //{ template: 'gateDeclared', label: '报关类型', width: '110' },
        //{ prop: 'valueDeclared', label: '申报价值', width: 100 },
        // { prop: 'outWeight', label: '预报重量', width: 60 },
        // { prop: 'outAmount', label: '预报费用', width: 90 },
        // { prop: 'outQuoteName', label: '预报渠道', width: 160 },
        //{ template: 'serviceStatus', label: '问题状态', width: 100 },
        //{ template: 'freight', label: '运费', width: 100 },
        //{ template: 'freightAdd', label: '加收', width: 100 },
        //{ template: 'updatedTime', label: '更新时间', width: 140 },
		//{ prop: 'realWeight', label: '实重', width: 120 },
		//{ prop: 'materialWeight', label: '体积重', width: 120 },
      ],
      multipleSelection: []
    }
  },
  async mounted(){
		Vue.prototype.$qiniu = await this.$api.uploadtoken() // 刷新七牛token有效期
		let branchList = JSON.parse(localStorage.getItem('branchlist'))
		for(let i = 0, len = branchList.length; i < len; i++){		
			let option = {
				value: branchList[i].branchCode,
				label: branchList[i].branchName,
			}
			if(branchList[i].branchCode == '85689'){
				//LHD特殊处理
				let setting = await this.$api.getDepartmentSetting('85689')
				if(setting && setting.value){
					let departArr = setting.value.split(",")
					option.children = []
					departArr.forEach((departName)=>{
						let childOption = {
							value: departName,
							label: departName
						}
						option.children.push(childOption);
					})
				}
			}
			this.providerOptions.push(option)
		}
		if(this.providerOptions.length > 0){
			this.spIdDepartName = [this.providerOptions[0].value]
			this.spId = this.providerOptions[0].value
			this.getbinfo(this.spId)
		}
		this.queryBillCount()		
  },     
  methods: {
    // 多选
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onProviderChanged(){
      if(this.spIdDepartName.length > 0){
        this.spId = this.spIdDepartName[0]
      }else{
        this.spId = ''
      }
    },
    // 重置表格
    getReset() {
      this.wayBillState = []
      this.clientConfirmBillval = []
    },
    buildQueryParams(pages){
      let params = { ...pages, timeType: 1, hidenInSettlement: '0' }
      if (this.clientConfirmBillval.length == 1 && this.clientConfirmBillval[0] == 1) params.branchConfirmed = 1
      if (this.clientConfirmBillval.length == 1 && this.clientConfirmBillval[0] == 2) params.branchConfirmed = 0
      if(this.wayBillStatus >= 0){
        params.wayBillStatus = this.wayBillStatus
      }
      // if(this.spIdDepartName.length > 0){
      //   params.spId = this.spIdDepartName[0]
      //   if(this.spIdDepartName.length == 2){
      //     params.spDepartName = this.spIdDepartName[1]
      //   }
      // }
      if (this.datetimerange) {
        params.startDate = this.datetimerange[0].substring(0, 10) + ' 00:00:00'
        params.endDate = this.datetimerange[1].substring(0, 10) + ' 23:59:59'
        if (date.formatDate(new Date(new Date(params.startDate).getTime() + 1000 * 3600 * 24 * 90), 'yyyy-MM-dd hh:mm:ss') < params.endDate) {
          this.$message.warning('运单时间范围不能超过30天')
          return { list: [], total: 0 }
        }
        if (params.startDate > params.endDate) {
          this.$message.warning('运单开始时间不能大于结束数据')
          return { list: [], total: 0 }
        }
      }
      this.wayBillNos = this.wayBillNos.trim().replaceAll('\n', ',')
      if (this.wayBillNos) {
        params = { ...pages }
        params.wayBillNos = this.wayBillNos
      }
      return params
    },
    // 表格查询
    async getTable(pages) {
      let params = this.buildQueryParams(pages)	
      let page = await this.$api.getWayBillPage(params)
      for(let i in page.list){
        page.list[i].amount = -page.list[i].inFreight-page.list[i].inFreightConditionAdd-page.list[i].inFreightAdd
        page.list[i].spName = this.getSpName(page.list[i])
      }
      console.log(page)
      return page;
    },
	//查询
	async queryWayBill(){
		this.wayBillStatus = -1		
        this.$refs[this.ref].currentChange(1)		
		this.queryBillCount()
	},
	async queryBillCount(){
		this.queryParams = this.buildQueryParams()
		let countList = await this.$api.getWayBillCountList(this.queryParams)
		this.billCountList = []
		let total = 0
		if(countList.length > 0){
			this.billCountList.push({tenantId: '', wayBillStatus: -1, wayBillStatusName: '全部', billCount: 0})
			for(let i = 0, len = countList.length; i < len; i++){
				total += countList[i].billCount;
				this.billCountList.push(countList[i]);
			}
			this.billCountList[0].billCount = total
			this.billCountLabel = this.getBillCountLabel(this.billCountList[0])
		}		
	},
	billCountItemChanged(){
		for(let i = 0, len = this.billCountList.length; i < len; i++){
			if(this.billCountLabel == this.getBillCountLabel(this.billCountList[i])){
				// this.spIdDepartName = []
				// if(this.billCountList[i].spId){
				// 	this.spIdDepartName.push(this.billCountList[i].spId)
				// 	if(this.billCountList[i].spDepartName){
				// 		this.spIdDepartName.push(this.billCountList[i].spDepartName)
				// 	}
				// }
				this.wayBillStatus = this.billCountList[i].wayBillStatus
				this.$refs[this.ref].currentChange(1)
				return;
			}
		}
	},	
	getBillCountLabel(item){
		switch(item.wayBillStatus){
		case 0:
			return '待走货' + item.billCount
		case 1:
			return '待提取' + item.billCount
		case 2:
			return '待签收' + item.billCount
		case 3:
			return '已签收' + item.billCount
		case 4:
			return '已退走' + item.billCount
		case 5:
			return '已作废' + item.billCount
		}
		return '全部' + item.billCount		
	},		
    // 子表查询
    async getTableDetailed(row) {
      if (!row.wayBillNo) return
      const res = await this.$api.billAdvanceAccountall({ wayBillId: row.wayBillId, timeType: 1, hidenInSettlement: '0', pageNum: 1, pageSize: 500 })
      return { list: res.list, total: res.list.length }
    },
    // 按票对账
    async getclientConfirmBill(flog) {
      try {
        await this.$api.confirmforbill(this.multipleSelection, flog)
        await this.submitForm()
      } catch (error) {
        this.$message.warning(error)
      }
    },
    //子表对账
    async getconfirmforbilldeat(row) {
      try {
        await this.$api.confirmforbilldeat([row], row.branchConfirmed)
      } catch (error) {
        this.$message.warning(error)
      } finally {
      }
    },
    // 显示备注
    getRemark(value) {
      let list = value.split(';')
      let str = ''
      for (var key in list) {
        let subStr = list[key].split('\r\n')
        if (subStr.length > 0) {
          str = str + subStr[0]
        }
      }
      return str
    },
	getSpName(row){
		if(row.inDepartName){
			return row.inDepartName;
		}else{
			return this.crrbranch(row.tenantId).branchName
		}
	},		
    // 设置备注
    setremark() {
      if (this.multipleSelection.length != 1) return this.$notify.error('不可选择多条数据！')
      this.$prompt('请输入备注', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(async ({ value }) => {
        // 按票备注(自己备注)：tenantId,spId,wayBillNo,tenantRemark,单条备注：tenantId,id,clientRemark（服务商备注）
        let data = { tenantId: localStorage.getItem('tenantId'), spId: this.multipleSelection[0].spId, wayBillNo: this.multipleSelection[0].wayBillNo, tenantRemark: value }
        await this.$api.costRecordremark([data])
        this.$notify.info('备注成功！')
        this.submitForm()
      })
    },
    // 行类名
    tableRowClassName({ row }) {
      if (this.multipleSelection.includes(row)) {
        return 'select'
      }
    },
    // 导出字段转义
    paraphrase(row, template) {
      if (template == 'spId') {
        return this.crrbranch(row.spId).branchName
      }
      if (template == 'createdTime') {
        return this.getDatetime(row.createdTime)
      }
      if (template == 'remark') {
        return row.remark ? this.getRemark(row.remark) : ''
      }
      if (template == 'trackInfo') {
        if (row.publicTrackTime && row.trackTime) {
          if (row.publicTrackTime > row.trackTime) {
            return '【' + row.publicTrackTime + row.trackPlace + '】' + row.publicTrackInfo
          } else {
            return row.trackInfo
          }
        } else if (row.publicTrackTime) {
          return '【' + row.publicTrackTime + row.trackPlace + '】' + row.publicTrackInfo
        } else {
          return row.trackInfo
        }
      }
      if (template == 'operatingStatus') {
        return (this.operatingStatusList.find(item => row.operatingStatus == item.key) || {}).value
      }
      if (template == 'serviceInfo') {
        if (row.serviceInfo) {
          return row.serviceInfo + (row.serviceInfoTime ? row.serviceInfoTime.substring(5, 16) : '') + (row.serviceInfoToPerson ? row.serviceInfoToPerson : '')
        }
      }
      if (template == 'battery') {
        return row.battery === '0' ? '无电' : row.battery === '1' ? '内电' : row.battery === '2' ? '外电' : '纯电'
      }
      if (template == 'gateDeclared') {
        return row.gateDeclared === '1' ? '报关' : '不报关'
      }
      if (template == 'serviceStatus') {
        return this.numtotitflog(row.serviceStatus, 0) ? '港前问题' : this.numtotitflog(row.serviceStatus, 1) ? '港后问题' : this.numtotitflog(row.serviceStatus, 4) ? '收货问题' : this.numtotitflog(row.serviceStatus, 5) ? '欠费问题' : this.numtotitflog(row.serviceStatus, 3) ? '待退走' : ''
      }
      if (template == 'updatedTime') {
        return this.getDatetime(row.updatedTime)
      }
    }
  }
}
</script>

<style scoped>
.tableExpand {
  background: #e3eefb !important;
}
.tableExpand /deep/ tr:hover > td {
  background: #d0e4fc;
  border-color: transparent;
}
.el-form-item__content .nobor /deep/ input {
  border: 0;
}
.el-form-item__content .nobor /deep/ input:hover {
  background: transparent;
}
.el-table__row .el-table_1_column_1 {
  overflow: hidden;
}
.el-table__row .selectspan {
  color: blue;
}
.el-table__row td.select .selectspan {
  color: white;
}
.el-table /deep/ .el-table__expand-column {
  overflow: hidden;
}
</style>